import styled from "styled-components";

const MainContent = styled.div`
  margin-left: 25px;
  overflow: auto;
  width: 100%;
`;

export default MainContent;



// WEBPACK FOOTER //
// ./src/components/layout/MainContent.js